const TAGS = {
    Registration: {
        B2C_QUICK_APP: 'b2c_aplikacja_def_rejestracja',
        B2B_QUICK_APP: 'b2b_aplikacja_def_rejestracja',
        B2C_FULL_APP: 'b2c_aplikacja_def_rejestracja',
        B2B_FULL_APP: 'b2b_aplikacja_def_rejestracja',
        B2C_NONE_APP: 'b2c_aplikacja_def_rejestracja',
        B2B_NONE_APP: 'b2b_aplikacja_def_rejestracja',
        BRAK_NONE_APP: 'all_brak_rynku_rejestracja',
        BRAK_WWW: 'all_brak_rynku_rejestracja_www',
        B2C_WWW: 'b2c_www_rejestracja',
        B2B_WWW: 'b2b_www_rejestracja'
    },
    Sale: {
        B2C_QUICK_APP: 's2s_sales_b2c_app_zalog_pro',
        B2B_QUICK_APP: 's2s_sales_b2b_app_zalog_pro',
        B2C_FULL_APP: 's2s_sales_b2c_app_zalog_pełne',
        B2B_FULL_APP: 's2s_sales_b2b_app_zalog_pełne',
        BRAK_QUICK_APP: 's2s_sales_app_inne',
        BRAK_NONE_APP: 's2s_sales_app_inne',
        B2C_QUICK_APP_N: 'n_sales_b2c_app_zalog_pro',
        B2B_QUICK_APP_N: 's2s_sales_b2b_app_zalog_pro',
        B2C_FULL_APP_N: 'n_sales_b2c_app_zalog_pełne',
        B2B_FULL_APP_N: 's2s_sales_b2b_app_zalog_pełne',
        BRAK_QUICK_APP_N: 'n_sales_app_inne',
        BRAK_NONE_APP_N: 'n_sales_app_inne',
        BRAK_WWW: 'all_brak_rynku_sprzedaz_www',
        B2C_WWW: '',
        B2B_WWW: '',
        SALES_LOVE_CHAT: 's2s_sales_b2c_love',
        SALES_O_MOBILE_B2C_CHAT: 's2s_sales_b2c_mobile_fbb_fix',
        SALES_O_MOBILE_B2B_CHAT: 's2s_sales_b2b_mobile',
        CHAT: 's2s_sales_all_kontakt'
    },
    Support: {
        B2C_QUICK_APP: 'bot,kontakt_b2c',
        B2B_QUICK_APP: 'bot,kontakt_b2b',
        B2C_FULL_APP: 'bot,kontakt_b2c',
        B2B_FULL_APP: 'bot,kontakt_b2b',
        BRAK_FULL_APP: 'bot,kontakt',
        BRAK_NONE_APP: 'bot,kontakt',
        BRAK_WWW: 'bot,kontakt,www',
        B2C_WWW: 'bot,kontakt_b2c',
        B2B_WWW: 'bot,kontakt_b2b'
    }
};

const getProcessByTag = (tag) => {
    if (!tag) {
        return;
    }
    const tagLower = tag.toLowerCase();
    let p = '';
    for (const [process, tags] of Object.entries(TAGS)) {
        for (const [genesysTag] of Object.entries(tags)) {
            if (genesysTag.toLowerCase() === tagLower) {
                p = process;
                break;
            }
        }
        if (p) {
            break;
        }
    }
    return p;
};

const getTagsByProcess = (process) => {
    return TAGS[process];
};

const getTagStringByProcess = (process, key) => {
    const tags = getTagsByProcess(process);
    return tags[key];
};

export { getProcessByTag, getTagsByProcess, getTagStringByProcess };
